module.exports = __webpack_public_path__ + "img/bus-sm-red.b67b29eb.svg";